// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__(67973)))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__(70643)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
